import { Controller } from "@hotwired/stimulus"
import Cookies from "js-cookie"

const expiresInDays = 7

export default class extends Controller {
  static values = { cookieName: String }

  connect() {
    if (Cookies.get(this.cookieNameValue)) this.#remove()
  }

  close() {
    Cookies.set(this.cookieNameValue, true, { expires: expiresInDays })
    this.#remove()
  }

  #remove() {
    this.element.remove()
  }
}
